import { DialogComponent, DialogCloseEvent } from '@theme/dialog';

/**
 * First-visit newsletter pop-up (snippets/gg-newsletter-popup.liquid).
 *
 * Everything a dialog needs — showModal, scroll lock, Escape / outside-click close,
 * the closing animation — is inherited from Horizon's DialogComponent. This adds
 * only WHEN it opens:
 *   · straight away when its own form just posted (the server rendered a message)
 *   · otherwise 3s after landing, unless dismissed within the last 30 days
 * Storage can be blocked (private mode) — then it shows and simply isn't remembered.
 *
 * @extends {DialogComponent}
 */
class NewsletterPopup extends DialogComponent {
  static storageKey = 'gg-nl-pop';
  static snoozeMs = 30 * 24 * 60 * 60 * 1000;
  static delayMs = 3000;

  #timer = 0;

  connectedCallback() {
    super.connectedCallback();
    this.addEventListener(DialogCloseEvent.eventName, this.#remember);

    if (this.querySelector('.gg-newsletter__message')) {
      this.showDialog();
    } else if (!this.#snoozed()) {
      this.#timer = window.setTimeout(() => this.showDialog(), NewsletterPopup.delayMs);
    }
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    clearTimeout(this.#timer);
    this.removeEventListener(DialogCloseEvent.eventName, this.#remember);
  }

  #snoozed() {
    try {
      const stamp = Number(localStorage.getItem(NewsletterPopup.storageKey));
      return Date.now() - stamp < NewsletterPopup.snoozeMs;
    } catch {
      return false;
    }
  }

  #remember = () => {
    try {
      localStorage.setItem(NewsletterPopup.storageKey, String(Date.now()));
    } catch {
      /* storage blocked — nothing to remember */
    }
  };
}

if (!customElements.get('gg-newsletter-popup')) customElements.define('gg-newsletter-popup', NewsletterPopup);
